import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { setSelectedCycle } from 'redux/selectedCycle';

import { useAppDispatch } from 'v2/resources/hooks/useAppSelector';
import { useWindowSizes } from 'v2/resources/hooks/useWindowSizes';
import { ICycle } from 'v2/resources/types/cycles';
import { INursery } from 'v2/resources/types/nurseries';

const useCardNursery = () => {
  const dispatch = useAppDispatch();
  const navigate = useHistory();

  const { isMobile, isTablet } = useWindowSizes();
  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null
  );

  const handleNavigatePondId = (id: number) => {
    navigate.push(`/pond/${id}`);
  };

  //TODO: REFACTOR IN FUTURE
  const handleNavigateCycle = (data: INursery, cycle: ICycle) => {
    localStorage.setItem('selected-cycle', JSON.stringify(cycle));
    dispatch(setSelectedCycle(cycle));
    navigate.push(`/cycle`, {
      pond: {
        ...data,
      },
    });
  };

  const handleOpenDropdown = (index: number) => {
    setOpenDropdownIndex((prev) => (prev === index ? null : index));
  };

  return {
    openDropdownIndex,
    isMobile,
    isTablet,
    handleOpenDropdown,
    handleNavigatePondId,
    handleNavigateCycle,
  };
};

export default useCardNursery;
